
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Currency } from '@components';
import { renderNumber } from '@share/utils';

import '../style.scss';

const zero = 0;

export interface IActivityCardPriceTemplateProps {
  currency: string;
  displayWalletSavings: boolean;
  marginatorPrice: number;
  marginatorPriceFinal: number | null | undefined;
  marginatorSavings: number;
  displaySupplierPublicPriceB2C?: boolean;
  pubPrice: number;
  breakdownTaxes?: boolean;
  /** Max wallet amount for "Save up to" when displayWalletSavings */
  maxClientCashAmountAllow?: number;
  walletClientCashName?: string;
}

export function ActivityCardPriceTemplate(props: IActivityCardPriceTemplateProps) {
  const {
    currency,
    displayWalletSavings,
    marginatorPrice,
    marginatorPriceFinal,
    marginatorSavings,
    displaySupplierPublicPriceB2C = false,
    pubPrice,
    breakdownTaxes,
    maxClientCashAmountAllow,
    walletClientCashName,
  } = props;

  const hasBadge =
    (displayWalletSavings && (marginatorPrice - (marginatorPriceFinal ?? 0)) > zero) ||
    (marginatorSavings > zero && !displayWalletSavings && !displaySupplierPublicPriceB2C);

  return (
    <div
      className={`activity-card-wrapper__price-new-template ${hasBadge ? 'activity-card-wrapper__price-new-template--has-badge' : ''}`}
    >
      {hasBadge && (
        <div className="activity-card-wrapper__price-new-template-badge">
          <Currency currency={currency} />
          {displayWalletSavings
            ? (marginatorPrice - (marginatorPriceFinal ?? 0) >= 1
                ? Math.floor(marginatorPrice - (marginatorPriceFinal ?? 0))
                : renderNumber(marginatorPrice - (marginatorPriceFinal ?? 0), 2))
            : (marginatorSavings >= 1 ? Math.floor(marginatorSavings) : renderNumber(marginatorSavings, 2))}{' '}
          <FormattedMessage id="result.hotel.card.savings.off" />
        </div>)}

      {/* Wallet "Save up to" row */}
      {displayWalletSavings && (
        <div className="activity-card-wrapper__price-new-template-line activity-card-wrapper__price-new-template-line--row activity-card-wrapper__price-new-template-line--savings">
          <span className="activity-card-wrapper__price-new-template-label">
            <FormattedMessage id="wallet.save.up.to.max" values={{ clientCashName: walletClientCashName ?? '' }} />
          </span>
          <span className="activity-card-wrapper__price-new-template-savings-value">
            {maxClientCashAmountAllow != null && maxClientCashAmountAllow >= 1
              ? renderNumber(maxClientCashAmountAllow, 2)
              : `<${renderNumber(1, 2)}`}
          </span>
        </div>)}

      {/* From + final price */}
      <div className="activity-card-wrapper__price-new-template-line activity-card-wrapper__price-new-template-line--from-row" style={{ marginTop: '4px', justifyContent: 'flex-end' }}>
        <span className="activity-card-wrapper__price-new-template-from-label">
          <span style={{ fontSize: '18px' }}>
            {pubPrice > zero && marginatorSavings > zero && !displayWalletSavings && !displaySupplierPublicPriceB2C && (
              <span className="activity-card-wrapper__price-new-template-crossed">
                <Currency currency={currency} />
                {renderNumber(pubPrice, 2)}
              </span>)}

            <span style={{ textTransform: 'lowercase', marginLeft: '12px', marginRight: '4px' }}><FormattedMessage id="from" /></span>

            <Currency currency={currency} />
            {renderNumber(marginatorPriceFinal, 2)}
          </span>
        </span>
      </div>

      {/* Taxes/fees line */}
      <div className="hotel-card-wrapper__price-new-template-line hotel-card-wrapper__price-new-template-line--taxes-fees">
        <FontAwesomeIcon icon={faCheck} className="activity-card-wrapper__price-new-template-check" />
        <FormattedMessage id={breakdownTaxes ? 'activity.price.without.taxes.fees' : 'result.hotel.card.total.with.taxes.fees'} />
      </div>
    </div>
  );
}
